
export const get_form_url = async (formName: string): Promise<string> => {
  try {
    const response = await fetch('/api/form-url', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ name: formName }),
    });
    
    if (!response.ok) {
      throw new Error('Failed to get form URL');
    }
    
    const data = await response.json();
    return data.url;
  } catch (error) {
    console.error('Error getting form URL:', error);
    throw error;
  }
};

export const isTurnstileEnabled = Boolean(__TURNSTILE_SITE_KEY__);

export const submitProtectedForm = async (formName: string, formData: FormData): Promise<Response> => {
  return fetch(`/api/forms/${formName}`, {
    method: 'POST',
    body: formData,
  });
};
